<template>
    <CommonBox :title="titles[updateType]" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="150px" :model="initForm" :rules="rules">
            <el-form-item label="Product Category" prop="ProductCategory">
                 <el-select  v-model="initForm.ProductCategory" placeholder="">
                        <el-option
                            v-for="item in productCategoryList"
                            :key="item.ID"
                            :label="item.ProductCategory"
                            :value="item.ID">
                        </el-option>
                    </el-select>
            </el-form-item>

            <el-form-item label="Product Model" prop="ProductModel">
                <el-input v-model="initForm.ProductModel"></el-input>
            </el-form-item>

        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
        updateType:{},
        initForm:{}
    },
    data () {
        return {
            titles:{
                add:"Add Model",
                edit:"Edit Model"
            },
            rules:{
                
                ProductModel:[{required: true, message: 'Please enter a model name', trigger: 'blur'}]
            },
            productCategoryList:""
        };
    },
    created () {},
    mounted () {
        this.$http.get("getAllDocumentsProductCategory",{},(data)=>{
            this.productCategoryList = data.data;
        });
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let methods = this.updateType === 'add' ? 'post' : 'put';
                let url = this.updateType === 'add' ? 'addDocumentsProductModel' : 'editDocumentsProductModel';
                 var numReg = /^[0-9]*$/;
                var numRe = new RegExp(numReg);
                if (!numRe.test(this.initForm.ProductCategory)) {
                  this.initForm.ProductCategory=this.initForm.CategoryID;
                }

                this.$http[methods](url,this.initForm,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>
